import { useState } from 'react'

import { useRouter } from 'next/router'

import { phoneMask } from '@/utils/masks'
import { validateEmail } from '@/utils/validations'

export type Form = {
  name: string
  lastname: string
  email: string
  phone: string
}
type UseFormContainerProps = {
  handleErrorMessage: (
    field: string,
    value: string,
    customValidate?: ((value: string) => boolean) | undefined,
    customErrorMessage?: string,
  ) => string | null | undefined
}
export const useFormContainer = ({
  handleErrorMessage,
}: UseFormContainerProps) => {
  const router = useRouter()

  const [form, setForm] = useState<Form>({
    name: '',
    lastname: '',
    email: '',
    phone: '',
  })

  const [submitted, setSubmitted] = useState(false)

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target
    setForm({
      ...form,
      [name]: name.includes('phone')
        ? phoneMask(value, router.locale as 'pt-BR' | 'en')
        : value,
    })
  }
  const formFields = Object.keys(form)
  const validate = formFields.map((field) => {
    let error: string | null | undefined
    if (field === 'email') {
      error = handleErrorMessage(
        field,
        form[field as keyof typeof form],
        validateEmail,
        'E-mail inválido',
      )
    } else {
      error = handleErrorMessage(field, form[field as keyof typeof form])
    }
    return error
  })
  const isExistErrors =
    validate.filter(
      (error) => error === 'E-mail inválido' || error === 'Campo obrigatório',
    ).length > 0 ||
    !form.name.trim() ||
    !form.email.trim() ||
    !form.phone.trim()

  const handleSubmitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (form.lastname) return
    setSubmitted(true)
    router.push('/thank-you')
  }

  return {
    router,
    submitted,
    form,
    onChange,
    setForm,
    isExistErrors,
    handleSubmitForm,
  }
}
